export default {
  SUPER_OYO_PITCH_PAGE: 'SuperOyoPitchScreen',
  RECONFIRMATION_PAGE:'ReconfirmationScreen'
} as const;
